import { CheckboxFieldPlugin } from "../CheckboxFieldPlugin";
import { CurrencyFieldPlugin } from "../CurrencyFieldPlugin";
import { DateFieldPlugin } from "../DateFieldPlugin";
import { MultiSelectFieldPlugin } from "../MultiSelectFieldPlugin";
import { NumberFieldPlugin } from "../NumberFieldPlugin";
import { SelectFieldPlugin } from "../SelectFieldPlugin";
import { TextFieldPlugin } from "../TextFieldPlugin";
import { customFieldPlugins } from "./customFieldPluginRegistrar";

let isInitialized = false;
let initPromise: Promise<void> | null = null;

/**
 * Registrar for custom-field plugins.
 *
 * Storybook hygiene: avoid pulling GraphQL-heavy plugins into the Storybook bundle.
 * - Safe plugins are registered synchronously below.
 * - Heavy plugins (Document, User) are registered only outside Storybook via a dynamic import
 *   guarded by import.meta.env.STORYBOOK. This prevents Rollup/Vite from resolving those modules
 *   in SB builds and keeps the SB bundle free from @regrello/graphql-api.
 *
 * Notes:
 * - Static imports get resolved even if later dead-code-eliminated, so use a dynamic import here.
 * - See also vite forbid-imports plugin which runs in generateBundle to warn only on included code.
 */
export async function initCustomFieldPluginRegistrar(): Promise<void> {
  if (isInitialized) {
    if (initPromise) {
      await initPromise;
    }
    return;
  }

  // Register safe plugins synchronously so callers that don't await still have base functionality.
  isInitialized = true;
  customFieldPlugins.push(
    CheckboxFieldPlugin,
    CurrencyFieldPlugin,
    DateFieldPlugin,
    MultiSelectFieldPlugin,
    NumberFieldPlugin,
    SelectFieldPlugin,
    TextFieldPlugin,
  );

  // Only register GraphQL-dependent plugins outside of Storybook builds.
  if (import.meta.env.STORYBOOK !== "true") {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    initPromise = import("./initCustomFieldPluginRegistrarHeavy").then((mod) => {
      mod.registerHeavyCustomFieldPlugins();
    });
    await initPromise;
  }
}
